import BrokerList from './BrokerList.page';

export default BrokerList;